import React from "react"
import {Container} from "./components"

export type ContainerProps = {
    containerRef?: React.RefObject<HTMLLIElement>
    isActive: boolean
    hijackClick: (event: React.MouseEvent) => void
    hijackMouseEnter: (event: React.MouseEvent) => void
    hijackMouseLeave: () => void
    marketingStyles: {linkColour?: string; fontWeight?: string}
    testId: string
    className: string
    index: number
    pin?: string
    mapping?: string
    hidden: boolean
    title: string
    children: React.ReactNode
}

const SnailItemContainer = (props: ContainerProps) => {
    const {
        containerRef,
        isActive,
        hijackClick,
        hijackMouseEnter,
        hijackMouseLeave,
        marketingStyles,
        testId,
        className,
        index,
        pin,
        mapping,
        hidden,
        title,
        children,
    } = props

    return (
        <Container
            ref={containerRef}
            isActive={isActive}
            onClick={hijackClick}
            onMouseEnter={hijackMouseEnter}
            onMouseLeave={hijackMouseLeave}
            marketingStyles={marketingStyles}
            data-testid={testId}
            className={className}
            data-index={index}
            data-pin={pin}
            data-mapping={mapping}
            isHidden={hidden}
            data-title={title}
        >
            {children}
        </Container>
    )
}

export default SnailItemContainer
